var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"amap-wrapper"},[_c('el-amap',{ref:"map",staticClass:"amap-box",style:({ width: _vm.width, height: _vm.height }),attrs:{"vid":'amap-vue-search',"center":_vm.center,"zoom":_vm.zoom,"events":_vm.events}},_vm._l((_vm.markers),function(marker,index){return _c('el-amap-marker',{key:index,attrs:{"position":marker}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }